// outsource
import { Table, Button } from "antd";

const PayrateBonusTable = ({ filteredData, loading, page, pageSize, onPageChange, formatMoney, onEdit }) => {
  // -------------------------- VAR --------------------------
  const moneyCell = (value) => {
    if (value === "" || value === null || value === undefined) return "";
    return formatMoney(value);
  };

  const columns = [
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      width: 180,
      align: "center",
      className: "payrate-bonus-col-name",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      width: 70,
      align: "center",
    },
    {
      title: "XERO Payrate",
      dataIndex: "xeroPayrate",
      key: "xeroPayrate",
      width: 100,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => moneyCell(v),
    },
    {
      title: "XERO Hours",
      dataIndex: "xeroHours",
      key: "xeroHours",
      width: 80,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => v || "",
    },
    {
      title: "XERO Pay",
      dataIndex: "xeroPay",
      key: "xeroPay",
      width: 95,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => moneyCell(v),
    },
    {
      title: "Non-XERO Payrate",
      dataIndex: "nonXeroPayrate",
      key: "nonXeroPayrate",
      width: 115,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => moneyCell(v),
    },
    {
      title: "Bonus Base",
      dataIndex: "bonusBase",
      key: "bonusBase",
      width: 100,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => moneyCell(v),
    },
    {
      title: "Bonus Step",
      dataIndex: "bonusStep",
      key: "bonusStep",
      width: 100,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => moneyCell(v),
    },
    {
      title: "Bonus Rate",
      dataIndex: "bonusRate",
      key: "bonusRate",
      width: 95,
      align: "center",
      className: "payrate-bonus-col-number",
      render: (v) => moneyCell(v),
    },
    {
      title: "Last Updated",
      dataIndex: "lastUpdated",
      key: "lastUpdated",
      width: 145,
      align: "center",
      className: "payrate-bonus-col-last-updated",
    },
    {
      key: "action",
      width: 55,
      align: "center",
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          className="payrate-bonus-edit-btn"
          onClick={() => onEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  // -------------------------- MAIN --------------------------
  return (
    <Table
      className="payrate-bonus-antd-table"
      columns={columns}
      dataSource={filteredData}
      rowKey="id"
      pagination={{ current: page, pageSize, onChange: onPageChange, showSizeChanger: false }}
      scroll={{ x: 1135 }}
      bordered
      loading={loading}
      rowClassName={(_, index) =>
        index % 2 === 0 ? "payrate-bonus-row-odd" : "payrate-bonus-row-even"
      }
    />
  );
};

export default PayrateBonusTable;
